import type React from 'react'
import clsx from 'clsx'
import { Popup as MaplibrePopup } from 'react-map-gl/maplibre'

import * as styles from './popup.css'

type Props = React.ComponentProps<typeof MaplibrePopup>
const Popup: React.FC<Props> = ({ children, ...rest }) => {
  return (
    <MaplibrePopup
      {...rest}
      closeOnMove
      className={clsx(styles.popup, rest.className)}
    >
      {children}
    </MaplibrePopup>
  )
}
export default Popup
